import { axios } from '../../clients/axios'
import nodeFormData from 'form-data'

export default {
  namespaced: true,
  state: {
    cachedUsers: [],
    selectedUser: {},
    tenants: [],
    aliases: []
  },
  getters: {
    getCachedUsers: (state) => {
      let usernames = []
      state.cachedUsers.map((user) => {
        usernames.push(user.username)
      })

      return usernames
    },
    getSelectedUser: (state, getters, rootState, rootGetters) => {
      if (state.selectedUser) {
        const aliases = rootGetters['users/getAliases']
        const alias = aliases.find(
          (a) =>
            a.tenantId === (state.selectedUser && state.selectedUser.userId)
        )
        state.selectedUser.alias = alias && alias.name
        state.selectedUser.aliasNumber = alias && alias.contactNumber
      }

      return state.selectedUser
    },
    getTenants: (state) => {
      return state.tenants.map((user) => {
        user.alias = state.aliases.find((a) => a.tenantId === user.userId)
        return user
      })
    },
    getAliases: (state) => {
      return state.aliases
    }
  },
  mutations: {
    fetchCachedUsers(state, users) {
      state.cachedUsers = users
    },
    fetchSelectedUser(state, user) {
      state.selectedUser = user
    },
    fetchTenants(state, tenants) {
      state.tenants = tenants
    },
    fetchAliases(state, aliases) {
      state.aliases = aliases
    }
  },
  actions: {
    async fetchCachedUsersAction(context, params) {
      const { username } = params

      const cachedUsers = await axios.get(
        `${process.env.VUE_APP_API_URL}/users/search?username=${username}`,
        { withCredentials: true }
      )
      context.commit('fetchCachedUsers', cachedUsers.data)

      return cachedUsers.data
    },
    async fetchSelectedUserAction(context, params) {
      try {
        const { username } = params
        const user = await axios.get(
          `${process.env.VUE_APP_API_URL}/users/user/${username}`,
          { withCredentials: true }
        )

        context.commit('fetchSelectedUser', user.data)

        return Promise.resolve(user.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async fetchTenantsAction(context) {
      const tenants = await axios.get(
        `${process.env.VUE_APP_API_URL}/users/tenants`,
        { withCredentials: true }
      )

      context.commit('fetchTenants', tenants.data)
    },
    async createTempUserAction(context, params) {
      const { email } = params
      const user = await axios.post(
        `${process.env.VUE_APP_API_URL}/users/email`,
        { email: email },
        { withCredentials: true }
      )

      context.commit('fetchSelectedUser', user.data)
    },
    async fetchActivationUserAction(context, params) {
      const { activationCode } = params

      const user = await axios.get(
        `${process.env.VUE_APP_API_URL}/public/users/tempUser/${activationCode}`,
        { withCredentials: true }
      )

      return user.data
    },
    async sendOTPRequestAction(context, params) {
      const { contactNumber1, userId, oldPass, username } = params
      try {
        const OTP = await axios.post(
          `${process.env.VUE_APP_API_URL}/public/users/generateOTP/${userId}`,
          {
            oldPass: oldPass,
            contactNumber1: contactNumber1,
            username: username
          },
          { withCredentials: true }
        )

        return Promise.resolve(OTP.data)
      } catch (err) {
        let response = 'There was an error processing your request.'
        if (err.response.data === 'UPDATE_USER_ERROR_CONTACT_NUMBER_EXISTS') {
          response = 'A user is already associated with this contact number.'
        }
        if (err.response.data === 'UPDATE_USER_ERROR_USERNAME_EXISTS') {
          response =
            'The username has already been taken. Please choose a different username.'
        }
        if (err.response.data === 'UPDATE_USER_ERROR_INVALID_PASSWORD') {
          response = 'The password you entered is invalid.'
        }
        return Promise.reject(response)
      }
    },
    async activateUserByIdAction(context, params) {
      // const form = new nodeFormData()
      const {
        userId,
        username,
        firstName,
        lastName,
        newPass,
        oldPass,
        birthday,
        contactNumber1,
        OTP
      } = params
      try {
        // form.append('username', username);
        // form.append('firstName', firstName);
        // form.append('lastName', lastName);
        // form.append('newPass', newPass);
        // form.append('oldPass', oldPass);
        // form.append('birthday', birthday);
        // form.append('contactNumber1', contactNumber1);
        // form.append('profilePicture', profilePicture);

        // const headers = {
        //   "Content-Type": 'multipart/form-data',
        // }

        // const user = await axios.put(`${process.env.VUE_APP_API_URL}/public/users/userId/${userId}`,
        //   form,
        //   {
        //     headers: headers,
        //     withCredentials: true,
        //   }
        // )

        const user = await axios.put(
          `${process.env.VUE_APP_API_URL}/public/users/userId/${userId}`,
          {
            username: username,
            firstName: firstName,
            lastName: lastName,
            newPass: newPass,
            oldPass: oldPass,
            birthday: birthday,
            contactNumber1: contactNumber1,
            OTP: OTP
          },
          { withCredentials: true }
        )

        return Promise.resolve(user.data)
      } catch (err) {
        let response = ''
        if (err.response.data === 'UPDATE_USER_ERROR_INVALID_PASSWORD') {
          response = 'The password you entered is invalid.'
        } else if (err.response.data === 'UPDATE_USER_ERROR_INVALID_OTP') {
          response = 'The OTP you entered is invalid.'
        } else {
          response = 'There was an error processing your request.'
        }
        return Promise.reject(response)
      }
    },
    async updateUserProfilePictureAction(context, params) {
      try {
        const form = new nodeFormData()
        const { profilePicture } = params

        form.append('profilePicture', profilePicture)

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        const user = await axios.put(
          `${process.env.VUE_APP_API_URL}/users/profilePicture`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return Promise.resolve(user.data)
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select an image (.jpg, .png)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        }
        return Promise.reject(response)
      }
    },
    async updateUserEmergencyContactsAction(context, params) {
      try {
        const { emergencyContacts } = params

        const user = await axios.put(
          `${process.env.VUE_APP_API_URL}/users/emergencyContacts`,
          {
            emergencyContacts: emergencyContacts
          },
          { withCredentials: true }
        )

        return Promise.resolve(user.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async fetchPasswordResetUserAction(context, params) {
      try {
        const { code } = params

        const user = await axios.get(
          `${process.env.VUE_APP_API_URL}/public/users/passwordresetcode/${code}`,
          { withCredentials: true }
        )

        return Promise.resolve(user.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async resetPasswordAction(context, params) {
      try {
        const { userId, forgotPassword, newPass } = params

        const user = await axios.put(
          `${process.env.VUE_APP_API_URL}/public/passwordreset`,
          {
            userId,
            forgotPassword,
            newPass
          },
          { withCredentials: true }
        )

        return Promise.resolve(user.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async resendActivationAction(context, params) {
      try {
        const { userId } = params

        const success = await axios.post(
          `${process.env.VUE_APP_API_URL}/users/resendActivation`,
          {
            userId: userId
          },
          { withCredentials: true }
        )

        return Promise.resolve(success)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async updateUserAction(context, params) {
      try {
        const {
          userId,
          subscriptionStart,
          subscriptionEnd,
          unitLimit,
          updateAllProperties,
          status,
          propertyLimit
        } = params

        const success = await axios.put(
          `${process.env.VUE_APP_API_URL}/users/user/update`,
          {
            userId: userId,
            subscriptionStart: subscriptionStart,
            subscriptionEnd: subscriptionEnd,
            unitLimit: unitLimit,
            updateAllProperties: updateAllProperties,
            status: status,
            propertyLimit: propertyLimit
          },
          { withCredentials: true }
        )

        return Promise.resolve(success)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async fetchLessorsAction() {
      try {
        const lessors = await axios.get(
          `${process.env.VUE_APP_API_URL}/users/lessors`,
          {
            withCredentials: true
          }
        )

        return Promise.resolve(lessors.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async fetchAliasesAction(context) {
      try {
        const aliases = await axios.get(
          `${process.env.VUE_APP_API_URL}/alias`,
          {
            withCredentials: true
          }
        )

        context.commit('fetchAliases', aliases.data)

        return aliases.data
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async updateAliasAction(context, params) {
      try {
        const { tenantId, propertyId, name } = params

        const alias = await axios.post(
          `${process.env.VUE_APP_API_URL}/alias`,
          {
            tenantId,
            propertyId,
            name
            // profilePicture,
          },
          {
            withCredentials: true
          }
        )

        return alias
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async resendBatchActivation() {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/users/resendBatchActivation`,
          {},
          { withCredentials: true }
        )

        return response
      } catch (err) {
        return Promise.reject(err.response)
      }
    }
  }
}
